import FieldWrapper from '@features/ui-form/components/FieldWrapper';
import Input, { InputProps } from '@features/ui-form/components/Input';
import { WrappedInputProps } from '@features/ui-form/types';
import { useTranslation } from 'next-i18next';

export const NameInput = ({
  value,
  onChange,
  placeholder,
  hideError = false,
  required = false,
  ...rest
}: WrappedInputProps) => {
  const { t } = useTranslation('common');

  return (
    <FieldWrapper name="name" label={t('spaceObject.name')} hideError={hideError} required={required}>
      <Input
        placeholder={placeholder ?? t('spaceObject.name.placeholder')}
        value={value}
        onChange={onChange}
        {...rest}
      />
    </FieldWrapper>
  );
};

export const NameToolbarInput = ({ value, onChange, placeholder, ...rest }: InputProps) => {
  const { t } = useTranslation('common');

  return (
    <Input
      placeholder={placeholder ?? t('spaceObject.name.placeholder')}
      value={value}
      onChange={onChange}
      sx={{ backgroundColor: 'white', width: 240 }}
      {...rest}
    />
  );
};
